// removed by extract-text-webpack-plugin
module.exports = {"container":"_3fb2eda1ae_src-common-PageLayout-_PageLayout_container"};


//////////////////
// WEBPACK FOOTER
// ./src/common/PageLayout/PageLayout.css
// module id = 935
// module chunks = 0